import { ProtocolEventsHeader } from '@/pages/Vaccination/components/task/header/ProtocolEventsHeader';
import { ProtocolEventsStructure } from '@/pages/Vaccination/components/task/structure/ProtocolEventsStructure';
import { TransformProtocol } from '@/pages/Vaccination/components/task/types';

import cl from './styles.module.scss';

interface ProtocolEventsTableProps {
  data: TransformProtocol[];
}

export const ProtocolEventsTable = ({ data }: ProtocolEventsTableProps) => {
  if (!data.length) {
    return null;
  }

  return (
    <div className={cl.table}>
      <div className={cl.wrap}>
        <ProtocolEventsHeader />
        {data?.map((item) => (
          <ProtocolEventsStructure key={item.structuralDivisionId} {...item} />
        ))}
      </div>
    </div>
  );
};
